import React, { useState, useMemo, useContext } from 'react'
import { makeStyles } from '@mui/styles'
import { Theme } from '@mui/material'
import "../css/receivefunds.css"
import { Scrollbars } from 'react-custom-scrollbars'
import {FirebaseContext} from "../../../context/firebase";


const useStyles = makeStyles((theme: Theme) => ({
  navIcon: {
    color: '#999 !important',
    fontSize: '1.7rem !important',
    fontWeight: '900 !important',
  },
  logo: {
    transition: 'height 0.4s ease 0s, opacity 0.3s ease 0s',
    margin: '0 auto',
  },
  logoHolder: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  paragraph: {
    lineHeight: 1.6,
    color: '#555',
    fontSize: '0.978rem',
    fontStyle: 'normal',
    textAlign: 'left',
    fontWeight: '400',
    marginBottom: '30px',
  },
  footer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: '1rem',
    [theme.breakpoints.down('md')]: {
      padding: '0rem',
    },
  },
  linkButton: {
    color: '#fff !important',
    backgroundColor: '#5d307f',
    borderColor: '#5d307f',
    marginLeft: '10px',
    display: 'inline-block',
    fontWeight: 400,
    textAlign: 'center',
    whiteSpace: 'nowrap',
    verticalAlign: 'middle',
    userSelect: 'none',
    border: '1px solid transparent',
    padding: '0.375rem 0.75rem',
    fontSize: '1rem',
    lineHeight: 1.5,
    borderRadius: '0.25rem',
    textDecoration: 'none',
    transition: 'all 0.15s ease-in-out',

    "&:hover": {
      color: '#000 !important',
      backgroundColor: '#e37927',
      borderColor: '#e37927',
    },

    [theme.breakpoints.down('sm')]: {
      marginLeft: '0',
      marginTop: '5px',
      display: 'block',
    },
  },
  asideInner: {
    padding: '1rem',
    width: '100%',
    height: '100%',

    [theme.breakpoints.down('md')]: {
      padding: '1rem',
    },
  },
}))

interface Props {
  handleBeneficiaryClose2: () => void
  setTransferActiveBeneficiary2: React.Dispatch<React.SetStateAction<string>>
  checkAccountNumber2: () => void
}

const BeneficiariesOtherPopup: React.FC<Props> = ({
  handleBeneficiaryClose2,
  setTransferActiveBeneficiary2,
  checkAccountNumber2,
}) => {
  const { data, error, refresh } = useContext(FirebaseContext);

  const classes = useStyles()
  const [search, setSearch] = useState('')

  const selectBeneficiaryHandle = (ben: string) => {
    setTransferActiveBeneficiary2(ben)
    handleBeneficiaryClose2()
    checkAccountNumber2()
  }

  // ✅ Filter for "Other Beneficiaries"
  const filteredBeneficiaries = useMemo(() => {
    const same = Array.isArray(data?.users?.[0]?.beneficiarySame)
      ? data.beneficiarySame
      : data?.users?.[0]?.beneficiarySame
      ? [data.beneficiarySame]
      : [];

    const other = Array.isArray(data?.users?.[0]?.beneficiaryOther) // ✅ corrected key
      ? data.beneficiaryOther
      : data?.users?.[0]?.beneficiaryOther
      ? [data.beneficiaryOther]
      : [];

    return [...same, ...other];
  }, [data]);

  return (
    <div id="sidebar-wrapper-beneficiaries-popup2" className="sidebar-wrapper-receive-funds">
      <div className="sidebar-receive-funds-beneficiariesmodal-dialog modal-dialog-scrollable">
        <aside className="sidebar-receive-funds-beneficiaries">
          <div className="funds-beneficiaries-header">
            <h6 className="funds-ben-header-h6">Beneficiaries</h6>
            <button
              type="button"
              className="btn-beneficiaries-funds close"
              onClick={handleBeneficiaryClose2}
            >
              ×
            </button>
          </div>

          <div className="funds-beneficiaries-body">
            <div style={{ margin: '1rem 0' }}>
              <div style={{ marginBottom: '10px' }}>
                {/* ✅ Enabled input with working search */}
                <input
                  type="text"
                  name="funds-beneficiaries-search"
                  id="funds-beneficiaries-search"
                  className="funds-beneficiaries-search"
                  placeholder="Search by name, bank, or account number..."
                  value={search}
                  onChange={e => setSearch(e.target.value)}
                />
              </div>

              <div style={{ marginBottom: '3rem', height: '230px' }}>
                <div style={{ position: 'relative', overflow: 'hidden' }}>
                  <Scrollbars
                    style={{ transform: 'translateZ(-100px)', height: '240px' }}
                    autoHide
                    autoHideTimeout={1000}
                    autoHideDuration={200}
                  >
                    <div id="bill-select-telecom-type-options" style={{ padding: '1rem 0', width: '100%' }}>
                      {filteredBeneficiaries.length > 0 
                        ? 
                      (
                        filteredBeneficiaries.map((item: any) => (
                          <div
                            key={item.id}
                            typeof="button"
                            className="bills-dropdown-button-xxx"
                            onClick={() => selectBeneficiaryHandle(item.name)}
                            style={{ width: "100%", display: "flex", justifyContent: "space-between" }}
                          >
                            <div className="mint-row" style={{ display: 'flex', alignItems: 'center' }}>
                              <div className="block-circle" style={{ marginRight: '0.5rem' }}>
                                {item.initial}
                              </div>
                              <div className="taylor">
                                <h6 className="mb-0">{item.name}</h6>
                                <p className="mb-0">{item.accountNumber}</p>
                              </div>
                            </div>
                            <div className="taylor">
                              <h6 className="mb-0" style={{ marginTop: '2px' }}>{item.bank}</h6>
                            </div>
                          </div>
                        ))
                      ) : (
                        <h6 className="funds-beneficiaries-h6">No Beneficiary Found</h6>
                      )}
                    </div>
                  </Scrollbars>
                </div>
              </div>
            </div>
          </div>
        </aside>
      </div>
    </div>
  )
}

export default BeneficiariesOtherPopup
